module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 60"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">     <circle cx=\"30.5\" cy=\"30.5\" r=\"28.5\" fill=\"#000\" fill-opacity=\".2\"/>     <path fill=\"#FFF\" d=\"M30 60a30 30 0 1 1 0-60 30 30 0 0 1 0 60zm0-1.7a28.3 28.3 0 1 0 0-56.6 28.3 28.3 0 0 0 0 56.6z\"/>     <path fill=\"#FFF\" d=\"M38.2 28c1.8 1.1 1.8 2.9 0 4l-10.5 6.3c-1.8 1-3.2.3-3.2-1.8v-13c0-2 1.4-2.9 3.2-1.8l10.5 6.4z\"/>   </g>"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn-play.svg
// module id = 354
// module chunks = 0